import {DarkThemeCustom} from './theme/DarkThemeCustom';
import CalcIcon from '@mui/icons-material/Calculate';
import React from 'react';
import {ConfigPage} from './pages/ConfigPage';

const AppConfig = {
  appName: 'BESS.Gen2 Configurator',
  defaultTheme: DarkThemeCustom,
  defaultRoute: 'config'
};

AppConfig.pages = [
  {
    name: 'Your configuraton',
    component: <ConfigPage />,
    sideBarIcon: <CalcIcon />,
    url: 'config',
  }
];


export {AppConfig};
